<template>
  <v-btn icon large slot="activator" :to="{ name: 'nachrichten' }">
    <v-badge right color="grey lighten-3" overlap>
      <span
        slot="badge"
        v-if="this.$store.getters.fetchNeueNachrichten > 0"
        color="black"
        style="color: black;"
      >{{ this.$store.getters.fetchNeueNachrichten }}</span>
      <v-icon :color="Farbe" large>local_post_office</v-icon>
    </v-badge>
  </v-btn>
</template>

<script>

// import { timer } from 'vue-timers'

export default {

  // timers: {
  //   vuexnachrichten: { time: 30000, autostart: true, repeat: true }
  // },

  components: {

  },
  data: () => ({

  }),
  computed: {
    Farbe: function () {
      if (this.$store.getters.fetchNeueNachrichten > 0) {
        return 'accent'
      } else {
        return 'grey'
      }
    }
  },
  mounted: function () {
  },

  methods: {
    async vuexnachrichten () {
      const data = await this.$store.dispatch('fetchNachrichten')
    }
  }
}
</script>
<style>
</style>